import { ChevronLeft, ChevronRight, ChevronUp, ChevronDown, Hand, Star } from "lucide-react";
import { type GestureDirection, type GestureAction } from "@/hooks/useAdvancedGestures";

interface GestureFeedbackProps {
  direction: GestureDirection | null;
  action: GestureAction | null;
}

export const GestureFeedback = ({ direction, action }: GestureFeedbackProps) => {
  if (!direction && action !== "longpress" && action !== "doubletap") return null;

  const getIcon = () => {
    if (action === "longpress") return <Hand className="h-8 w-8" />;
    if (action === "doubletap") return <Star className="h-8 w-8" />;
    
    switch (direction) {
      case "left": return <ChevronLeft className="h-8 w-8" />;
      case "right": return <ChevronRight className="h-8 w-8" />;
      case "up": return <ChevronUp className="h-8 w-8" />;
      case "down": return <ChevronDown className="h-8 w-8" />;
      default: return null;
    }
  };

  const getPosition = () => {
    switch (direction) {
      case "left": return "left-8 top-1/2 -translate-y-1/2";
      case "right": return "right-8 top-1/2 -translate-y-1/2";
      case "up": return "top-8 left-1/2 -translate-x-1/2";
      case "down": return "bottom-8 left-1/2 -translate-x-1/2";
      default: return "top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2";
    }
  };

  return (
    <div className={`fixed ${getPosition()} z-50 pointer-events-none animate-fade-in`}>
      <div className="bg-primary/90 text-primary-foreground rounded-full p-3 shadow-glow backdrop-blur-sm">
        {getIcon()}
      </div>
    </div>
  );
};
